'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _AutoComplete = require('material-ui/AutoComplete');

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RolesForm = function (_React$Component) {
	_inherits(RolesForm, _React$Component);

	function RolesForm(props) {
		_classCallCheck(this, RolesForm);

		var _this = _possibleConstructorReturn(this, (RolesForm.__proto__ || Object.getPrototypeOf(RolesForm)).call(this, props));

		_this.onNameChange = _this.onNameChange.bind(_this);
		_this.onRoleCategoryChange = _this.onRoleCategoryChange.bind(_this);
		_this.cancel = _this.cancel.bind(_this);
		_this.onClickSubmit = _this.onClickSubmit.bind(_this);
		return _this;
	}

	_createClass(RolesForm, [{
		key: 'componentWillMount',
		value: function componentWillMount() {

			var initialState = {
				nameErrorMsg: '',
				roleErrorMsg: '',
				roleCategory: null
			};

			if (typeof this.props.role !== 'undefined') {
				initialState.role = this.props.role;
			} else {
				initialState.role = {
					name: ''
				};
			}

			if (typeof this.props.role !== 'undefined') {
				initialState.role = this.props.role;
			}

			this.setState(initialState);
		}
	}, {
		key: 'onClickSubmit',
		value: function onClickSubmit() {
			this.props.submit(this.state.role);
		}
	}, {
		key: 'onNameChange',
		value: function onNameChange(event, value) {
			this.setState({
				role: _extends({}, this.state.role, {
					name: value
				})
			});
		}
	}, {
		key: 'onRoleCategoryChange',
		value: function onRoleCategoryChange(choosen) {
			var roleId = this.props.roleCategories.filter(function (role) {
				return role.name === choosen;
			});
			this.setState({
				role: _extends({}, this.state.role, {
					roleCategoryId: roleId[0].id
				})
			});
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			this.props.cancel();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    requestingCreateRole = _props.requestingCreateRole,
			    roleCategories = _props.roleCategories;
			var _state = this.state,
			    role = _state.role,
			    nameErrorMsg = _state.nameErrorMsg;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_TextField2.default, {
						hintText: 'Nome',
						floatingLabelText: 'Nome',
						floatingLabelFixed: true,
						onChange: this.onNameChange,
						value: role.name,
						errorText: nameErrorMsg,
						fullWidth: true
					}),
					_react2.default.createElement(_AutoComplete2.default, {
						floatingLabelText: 'Cargo Agrupado',
						floatingLabelFixed: true,
						filter: _AutoComplete2.default.caseInsensitiveFilter,
						dataSource: roleCategories.map(function (rc) {
							return rc.name;
						}),
						onNewRequest: this.onRoleCategoryChange
					})
				),
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_RaisedButton2.default, { label: 'Cancelar', onClick: this.cancel }),
					_react2.default.createElement(_RaisedButton2.default, {
						primary: true, label: 'Enviar',
						onClick: this.onClickSubmit,
						style: { marginLeft: '1rem' }
					}),
					requestingCreateRole && _react2.default.createElement(_CircularProgress2.default, null)
				)
			);
		}
	}]);

	return RolesForm;
}(_react2.default.Component);

exports.default = RolesForm;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/roles/RolesForm.js
// module id = 1315
// module chunks = 0